/**
 * `localStorage` / `sessionStorage` that never throw: a page in a private
 * window, an iframe with storage partitioned off, or a browser told to
 * block site data raises on the accessor itself. Everything the runtime
 * remembers (the visitor key, a chat session, a split's bucket, a rule
 * fired once, a sequence's step) is a convenience - it must degrade to
 * "forgotten", never to a script error on the customer's page.
 */

export type Store = "localStorage" | "sessionStorage"

export function read(which: Store, key: string): string | null {
  try {
    return window[which].getItem(key)
  } catch {
    return null
  }
}

export function write(which: Store, key: string, value: string) {
  try {
    window[which].setItem(key, value)
  } catch {
    // Storage is full or blocked: the value is simply not remembered.
  }
}

export function remove(which: Store, key: string) {
  try {
    window[which].removeItem(key)
  } catch {
    // Blocked storage never held it in the first place.
  }
}
